import React from "react";
import { Play } from "lucide-react";

export const VideoCard = ({ video }) => (
  <a
    href={`https://youtu.be/${video.id}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`video-card-${video.id}`}
    className="group block border border-ivory/15 text-left transition-colors duration-300 hover:border-ivory/40"
    aria-label={`Watch ${video.title} on YouTube`}
  >
    <div className="relative aspect-video overflow-hidden">
      <img
        src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
        alt={video.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand/95 text-ivory transition-transform duration-300 group-hover:scale-110">
          <Play className="ml-0.5 h-5 w-5 fill-current" />
        </span>
      </span>
    </div>
    <div className="p-5">
      <p className="eyebrow text-ivory/50">{video.episode}</p>
      <h3 className="mt-2 font-serif text-xl leading-snug text-ivory">{video.title}</h3>
      <p className="mt-2 text-[0.7rem] uppercase tracking-[0.2em] text-ivory/45">Watch on YouTube</p>
    </div>
  </a>
);
